import React from 'react';
import ZoomableImage from '../../../../../UI/ZoomableImage/ZoomableImage.js';
import { DillardsPinchZoom } from '../../../../../UI/PinchZoom/PinchZoom.js';
import ProductMainVideo from './ProductMainVideo';
import { shouldMock } from '../../../../../../util/mockProduct';
// import DeepUI from '../../../../../UI/DeepAR/DeepUI.js';
export class MainImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      qvImageZoomed: false,
      x: null,
      y: null,
      newZoomSize: {},
      // runOnce:false
    };
  }

  toggleQvImageZoomed = (event) => {
    const currentState = this.state.qvImageZoomed;
    this.setState({ qvImageZoomed: !currentState });
    const x = event.clientX;
    const y = event.clientY;

    const xPos = x - 120;
    const yPos = y - 20;

    this.setState({ x: xPos });
    this.setState({ y: yPos });
  };

  mainImageClick = (event) => {
    this.props.contentData.productLayout == 'QuickViewDisplay'
      ? this.toggleQvImageZoomed(event)
      : this.props.mainImageClicked();
  };

  componentDidMount() {
    if (this.props.quickViewMainImage && this.props.passedAppFunctions.siteFormat != 'desktop') {
      DillardsPinchZoom();
      $('div.qv-pinch-zoom').each(function () {
        new RTP.PinchZoom($(this), {});
      });
    }
  }

  componentDidUpdate() {
    this.state.qvImageZoomed ? $('.main-img-wrapper').scrollTop(this.state.y) : null;
    this.state.qvImageZoomed ? $('.main-img-wrapper').scrollLeft(this.state.x) : null;
  }
  getAltTextFromAltData(imageName) {
    var altImagesFromContent = this.props.contentData.altImages || [];
    for (var iAlt = 0; iAlt < altImagesFromContent.length; iAlt++) {
      var thisAlt = altImagesFromContent[iAlt];
      if (imageName == thisAlt.imageName) {
        return thisAlt.altText;
      }
    }
    return '';
  }
  renameAltText(altFromServer) {
    let altTextArr = altFromServer.split(' - ');
    return `${this.props.contentData.brandNameForTitle} ${altTextArr[2]}, ${altTextArr[0].replace('Color:', '')} - ${altTextArr[1]}`;
  }
  render() {
    var contentData = this.props.contentData,
      mainImagePath = '',
      mainImage = '',
      altText = '';
    if (this.props.productDisplayEcard === true) {
      mainImagePath = '//dimg.dillards.com/is/image/DillardsZoom/mainProduct/' + contentData.fullImage.imageNameForUrl;
      mainImage = `${mainImagePath + '/' + contentData.fullImage.imageNameNoPath}.jpg`;
      altText = contentData.fullImage.altText;
    } else {
      mainImagePath = '//dimg.dillards.com/is/image/DillardsZoom/mainProduct/' + contentData.fullImage.imageNameForUrl;
      mainImage = `${mainImagePath + '/' + contentData.fullImage.imageNameNoPath}.jpg`;
      altText = contentData.fullImage.altText;
    }

    var selectedMainImg = this.props.selectedMainImg;

    if (this.props.productDisplayEcard === true && selectedMainImg.length !== 4) {
      selectedMainImg = contentData.ecardImages[0].imageName;
    }

    //TEST FOR FAKE MODEL
    if (typeof window != 'undefined' && window.injectedMainImageFunction) {
      selectedMainImg = window.injectedMainImageFunction(selectedMainImg);
    }
    //END TEST FOR FAKE MODEL

    if (selectedMainImg) {
      mainImagePath = '';
      if (this.props.productDisplayEcard === true && selectedMainImg.indexOf('$') > -1) {
        mainImagePath = '//dimg.dillards.com/is/content/DillardsZoom/DillardsZoom';
        mainImage = `${mainImagePath}/ecard_${selectedMainImg}.gif`;
      } else if (this.props.productDisplayEcard === true) {
        mainImagePath =
          '//dimg.dillards.com/is/image/DillardsZoom/mainProduct/' + contentData.fullImage.imageNameForUrl;
        mainImage = `${mainImagePath}/ecard_${selectedMainImg}.jpg`;
      } else {
        mainImagePath =
          '//dimg.dillards.com/is/image/DillardsZoom/mainProduct/' + contentData.fullImage.imageNameForUrl;
        mainImage = `${mainImagePath}/${selectedMainImg}.jpg`;
      }
    }

    //update alt text to alt image's alt text if possible
    altText =
      this.getAltTextFromAltData(selectedMainImg || this.props.contentData.fullImage.imageNameNoPath) || altText;

    let tempAltText = altText.includes(' - ') ? this.renameAltText(altText) : altText;
    altText = tempAltText;

    var layoutType = this.props.contentData.productLayout != undefined ? this.props.contentData.productLayout : '';
    var siteFormat = this.props.passedAppFunctions ? this.props.passedAppFunctions.siteFormat : '';
    var mainImgWidth;
    var mainImgHeight;
    switch (layoutType) {
      case 'OutfitDisplay':
      case 'BundleDisplay':
        (mainImgWidth = this.props.mainImgWidth != undefined ? this.props.mainImgWidth : 545),
          (mainImgHeight = this.props.mainImgHeight != undefined ? this.props.mainImgHeight : 632);
        break;

      case 'OutfitComponent':
        (mainImgWidth = this.props.mainImgWidth != undefined ? this.props.mainImgWidth : 285),
          (mainImgHeight = this.props.mainImgHeight != undefined ? this.props.mainImgHeight : 331);
        break;

      case 'ProductDisplay':
        (mainImgWidth = this.props.mainImgWidth != undefined ? this.props.mainImgWidth : 570),
          (mainImgHeight = this.props.mainImgHeight != undefined ? this.props.mainImgHeight : 661);
        break;

      case 'ProductItemAttrDisplay':
        (mainImgWidth = this.props.mainImgWidth != undefined ? this.props.mainImgWidth : 445),
          (mainImgHeight = this.props.mainImgHeight != undefined ? this.props.mainImgHeight : 516);
        break;

      case 'ProductItemDisplay':
        (mainImgWidth = this.props.mainImgWidth != undefined ? this.props.mainImgWidth : 445),
          (mainImgHeight = this.props.mainImgHeight != undefined ? this.props.mainImgHeight : 516);
        break;

      case 'ProductDisplayChanel':
        (mainImgWidth =
          this.props.mainImgWidth != undefined
            ? this.props.mainImgWidth
            : this.props.contentData?.altImages
              ? 475
              : 570),
          (mainImgHeight =
            this.props.mainImgHeight != undefined
              ? this.props.mainImgHeight
              : this.props.contentData?.altImages
                ? 551
                : 661);
        break;

      case 'ProductItemDisplayChanel':
        (mainImgWidth = this.props.mainImgWidth != undefined ? this.props.mainImgWidth : 475),
          (mainImgHeight = this.props.mainImgHeight != undefined ? this.props.mainImgHeight : 551);
        break;

      case 'QuickViewDisplay':
        (mainImgWidth = this.props.mainImgWidth != undefined ? this.props.mainImgWidth : 570),
          (mainImgHeight = this.props.mainImgHeight != undefined ? this.props.mainImgHeight : 661);
        break;

      default:
        (mainImgWidth = this.props.mainImgWidth != undefined ? this.props.mainImgWidth : 570),
          (mainImgHeight = this.props.mainImgHeight != undefined ? this.props.mainImgHeight : 661);
    }

    const mock = shouldMock(this.props.selectedMainImg);
    if (mock) {
      return <ProductMainVideo src={mock.video} poster={mock.poster} onShow={mock.onShow} />;
    }

    return (
      <figure className='main-img-wrapper' id='main-img-wrapper'>
        {this.props.quickViewMainImage && siteFormat !== 'desktop' ? (
          <div className='pinch-zoom-container'>
            <div className='qv-pinch-zoom'>
              <img src={mainImage} alt={altText} />
            </div>
          </div>
        ) : (siteFormat != 'desktop' && layoutType == 'OutfitComponent') ||
          siteFormat === 'tablet' ||
          siteFormat === 'mobile' ? (
          <img src={mainImage} alt={altText} onClick={this.props.openPhotoSwipe} />
        ) : (
          <>
            <ZoomableImage
              baseImage={{
                alt: altText,
                src: mainImage,
                width: mainImgWidth,
                height: mainImgHeight,
              }}
              largeImage={{
                alt: altText,
                src: mainImage,
                width: 1760,
                height: 2040,
              }}
              thumbnailImage={{
                alt: altText,
                src: mainImage,
              }}
            />
            <a href={mainImage} target='_blank' style={{ color: 'white', fontSize: '12px' }} rel='noreferrer'>
              Open Full Size Image
            </a>
          </>
        )}
      </figure>
    );
  }
}

export default MainImage;
